import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import { Page, Fab } from "components/support";
import { colors } from "assets";

import Filter from "./filter";
import DataTable from "./data-table";

class UserView extends Component {
  constructor(props) {
    super(props);
    this.presenter = props.presenter;
    this.router = props.transition.router;
  }

  redirectTo = (target, params) => {
    this.router.stateService.go(target, params, {});
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { companySearchOptions, filter, loading } = viewModel;

    return (
      <Page>
        <Row>
          <Col xs={12}>
            <Typography type="display1" className="pb-sm">
              Usuários
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Filter
              loading={loading}
              onFilter={filter => presenter.handleFilterChange(filter)}
              companySearchOptions={companySearchOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <DataTable
              redirectTo={this.redirectTo}
              filter={filter}
              loading={loading}
              setLoading={loading => presenter.setLoading(loading)}
            />
          </Col>
        </Row>
        <Fab
          backgroundColor={colors.button.secondary}
          onClick={() =>
            this.redirectTo("app.registration.user.form", { userUuid: "novo" })
          }
          icon="add"
        />
      </Page>
    );
  }
}

export default UserView;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/user.view.jsx